<template>
  <validation-observer ref="dataForm">
    <b-form class="auth-register-form mt-2" @submit.prevent="register">
      <b-row>
       <b-col md="6">
              <!-- .first_name -->
              <b-form-group
                id="input-group-27"
                :label="$t('edu_contents.name')"
                label-for="input-27"
              >
                <validation-provider
                  #default="{ errors }"
                  name="name"
                  vid="name"
                  rules="required"
                >
                  <b-form-input
                    id="input-27"
                    v-model="data.name"
                    type="text"
                    :placeholder="$t('edu_contents.name')"
                  >
                  </b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <!-- .first_name -->
              <b-form-group
                id="input-group-27"
                :label="$t('edu_contents.name_en')"
                label-for="input-27"
              >
                <b-form-input
                  id="input-27"
                  v-model="data.name_en"
                  type="text"
                  :placeholder="$t('edu_contents.name_en')"
                >
                </b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                id="input-group-27"
                :label="$t('edu_contents.duration')"
                label-for="input-27"
              >
                <validation-provider
                  #default="{ errors }"
                  name="duration"
                  vid="duration"
                  rules="required"
                >
                  <cleave
                    id="time"
                    v-model="data.duration"
                    class="form-control"
                    :raw="false"
                    :options="time"
                    :placeholder="$t('edu_contents.duration')"
                  />

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                id="input-group-27"
                :label="$t('edu_contents.code')"
                label-for="input-27"
              >
                <validation-provider
                  #default="{ errors }"
                  name="code"
                  vid="code"
                  rules="required"
                >
                  <b-form-input
                    id="time"
                    v-model="data.code"
                    class="form-control"
                    type="text"
                    :placeholder="$t('edu_contents.code')"
                  />

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <!-- .last_name -->
              <b-form-group
                id="input-group-28"
                :label="$t('edu_contents.description')"
                label-for="input-28"
              >
                <validation-provider
                  #default="{ errors }"
                  name="description"
                  vid="description"
                  rules="required"
                >
                  <ckeditor
                    :config="{ contentsLangDirection: 'rtl',versionCheck : false }"
                    name="textarea"
                    v-model="data.description"
                    rows="4"
                    :placeholder="$t('edu_contents.description')"
                  ></ckeditor>

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <!-- .last_name -->
              <b-form-group
                id="input-group-28"
                :label="$t('edu_contents.description_en')"
                label-for="input-28"
              >
                <ckeditor
                  :config="{ contentsLangDirection: 'ltr',versionCheck : false }"
                  name="textarea"
                  v-model="data.description_en"
                  rows="4"
                  :placeholder="$t('edu_contents.description_en')"
                ></ckeditor>
              </b-form-group>
            </b-col>
      </b-row>
    </b-form>
  </validation-observer>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import Cleave from "vue-cleave-component";
import "cleave.js/dist/addons/cleave-phone.us";

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    required,
    Cleave,
  },
  data() {
    return {
      data: {
        duration:'01:00'
      },
      time: {
        time: true,
        timePattern: ["h", "m"],
      },
    };
  },
  methods: {
    async returnData() {
       const isValid = await this.$refs.dataForm.validate();
      if (!isValid) {
        return { valid: false };
      }
     return { valid: true, data: this.data };
    },
  },
};
</script>

<style>
</style>